import { LibValidators } from '@core/helpers';
import { ValidatorFn } from '@angular/forms';
import { TranslateService } from '@project/translate';

export function getPasswordValidators(): ValidatorFn[] {
  return [
    LibValidators.required(TranslateService.localize('validations.required')),
    LibValidators.minLength(4, TranslateService.localize('validations.min-length', { count: 4 })),
  ];
}
